import { singleSignOn } from '@/axios'

export default {
  login (payload) {
    const fcmToken =
      (typeof payload?.fcm_token === 'string' && payload.fcm_token.trim()) ||
      (typeof localStorage.getItem('fcmToken') === 'string' &&
        localStorage.getItem('fcmToken').trim()) ||
      ''
    return singleSignOn().post('sso-login', {
      ...payload,
      fcm_token: fcmToken
    })
  },
  forgetPassword (payload) {
    return singleSignOn().post('sso-forget-password', payload)
  },
  checkUser (paylod) {
    return singleSignOn().post('sso-check', paylod)
  },
  register (payload) {
    return singleSignOn().post('sso-signup', payload)
  },
  sendOtp (payload) {
    return singleSignOn().post('sso-send-otp', payload)
  },
  checkOtp (payload) {
    return singleSignOn().post('sso-verify-otp', payload)
  },
  logout () {
    return singleSignOn().post('sso-logout')
  },
  sendFirebase (payload) {
    return singleSignOn().patch('v1/fcm-tokens', { fcm_token: payload })
  }
}
